import {Injectable} from '@angular/core';

export interface Options {
    type: string;
    description: string;
    actions?: any;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor() {
    }

    publish(options: Options): void {
        const toast: HTMLBthToastElement = document.querySelector('bth-toast');
        toast.publish(options as any);
    }

}
